import { render, staticRenderFns } from "./ContentPlaceholders.vue?vue&type=template&id=b2e7ac64"
import script from "./ContentPlaceholders.vue?vue&type=script&lang=js"
export * from "./ContentPlaceholders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports